// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import { Integrations } from "@sentry/tracing";
import { ReportingObserver as ReportingObserverIntegration } from "@sentry/integrations";

const online = ENV_ISONLINE;
const isProd = ENV_ISPROD;
const dsn = !online
	? "https://fea75ff88ca445d2a51fc18e5bf1a09c@sentry.ezbuy.com/9"
	: "https://ef1db999af9d41e5af27a827fbc23d0d@sentry.ezbuy.com/7";

const integrations = [
	new ReportingObserverIntegration(),
	new Integrations.BrowserTracing({
		beforeNavigate: (context) => {
			return {
				...context,
				name: replacePathname(location.pathname),
			};
		},
	}),
];

Sentry.init({
	serverName: "OPTIMUS_LITB",
	integrations,
	dsn,
	// Note: if you want to override the automatic release value, do not set a
	// `release` value here - use the environment variable `SENTRY_RELEASE`, so
	// that it will also get attached to your source maps
	// release: SENTRY_RELEASE ? SENTRY_RELEASE.id : NEXT_PUBLIC_COMMIT_SHA,
	tracesSampler: () => {
		return 1;
	},
	environment: online ? "online" : isProd ? "dev" : "test",
	ignoreErrors: [
		"getAttribute",
		// Heavy Ad Intervention
		"Ad was removed",
	],
	denyUrls: [
		/ctrlitb.rightinthebox.com/gi,
		/go-mpulse.net/gi,
		/bing.com/gi,
		/\/active\/\//gi,
	],
});

function replacePathname(pathname = "") {
	if (pathname.match(/\/active\//)) {
		return "/active";
	}
	return pathname;
}
